import { Highlightable, ListKeyManagerOption } from '@angular/cdk/a11y';
import {
  ChangeDetectorRef,
  Directive,
  ElementRef,
  Input,
  inject,
  output,
} from '@angular/core';

import { focusElement } from '@plugins/client/utils';

import { ListDirective } from './list.directive';

@Directive({
  selector: '[pluginsListItem]',
  standalone: true,
  host: {
    '[attr.tabindex]': 'setTabIndex()',
    '[class.list-item-active]': 'isActive()',
    '(focus)': 'handleFocus()',
  },
  exportAs: 'pluginsListItem',
})
export class ListItemDirective implements ListKeyManagerOption, Highlightable {
  private readonly list = inject(ListDirective);
  private readonly element = inject(ElementRef).nativeElement as HTMLElement;
  private readonly cdr = inject(ChangeDetectorRef);

  readonly pluginsListOnSelect = output<ListItemDirective>();

  @Input('pluginsListItemInitial') initial = false;
  @Input('pluginsListItemOrder') set order(val: number) {
    this._order = val;
    this.list.onItemOrderChange();
  }

  get order() {
    return this._order;
  }
  private _order = 0;

  disabled = false;

  selectItem() {
    this.pluginsListOnSelect.emit(this);
  }

  handleFocus() {
    this.list.setActiveItem(this);
  }

  focus() {
    focusElement(this.element);
  }

  blur() {
    this.element.blur();
  }

  isActive() {
    return this.list.isActive(this);
  }

  setTabIndex() {
    return this.isActive() ? '0' : '-1';
  }

  detectChanges() {
    this.cdr.detectChanges();
  }

  getLabel() {
    return '';
  }

  setActiveStyles() {}

  setInactiveStyles() {}
}
